// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c93b1331","247":"e4123354","307":"35ad55c9","627":"62892a1c","834":"b72f3711","867":"72a45b71","907":"97417902","923":"5e9d4274","938":"98014b32"}[chunkId] + ".chunk.js";
};